module.exports = __webpack_public_path__ + "img/un.3835716.svg";